import React from "react";
import { useConfig } from "../../contexts/ConfigContext";
import { useLanguage } from "../../contexts/LanguageContext";
import "./ProjectInfo.css";

const ProjectInfo: React.FC = () => {
  const { config } = useConfig();
  const { t } = useLanguage();

  return (
    <div className="project-info">
      <div className="info-grid">
        <div className="info-item">
          <div className="info-label">{t("name")}</div>
          <div className="info-value">{config?.name || "N/A"}</div>
        </div>
        <div className="info-item">
          <div className="info-label">{t("description")}</div>
          <div className="info-value">{config?.description || "N/A"}</div>
        </div>
      </div>
    </div>
  );
};

export default ProjectInfo;
